<template>
	<div class="m-portlet m-portlet--brand betted-ratio">
		<div class="_m-portlet__head filter-container">
			<div class="row">
				<div class="col-12 col-sm-12">
					<div class="form-group m--margin-top-10">
						<div class="m-radio-inline">
							<label class="m-radio">
								<input type="radio" :value="1" v-model="gameFilter"> Miền Bắc
								<span></span>
							</label>
							<label class="m-radio">
								<input type="radio" :value="4" v-model="gameFilter"> Miền Trung
								<span></span>
							</label>
							<label class="m-radio">
								<input type="radio" :value="2" v-model="gameFilter"> Miền Nam
								<span></span>
							</label>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 col-lg-3">
					<div class="input-group">
						<div class="input-group-prepend">
							<div class="input-group-text limit-point">
								<label class="m-checkbox m-checkbox--success">
									<input v-model="filterVisible['2d']" type="checkbox">
									<span></span>
								</label>
							</div>
							<span class="input-group-text">2D &gt;=</span>
						</div>
						<input type="text" class="form-control m-input" v-model="propFilter['2d']">
					</div>
				</div>
				<div class="col-12 col-lg-3">
					<div class="input-group">
						<div class="input-group-prepend">
							<div class="input-group-text limit-point">
								<label class="m-checkbox m-checkbox--success">
									<input v-model="filterVisible['3d']" type="checkbox">
									<span></span>
								</label>
							</div>
							<span class="input-group-text">3D &gt;=</span>
						</div>
						<input type="text" class="form-control m-input" v-model="propFilter['3d']">
					</div>
				</div>
				<div :class="'col-12 ' + (gameFilter == 2 ? 'col-lg-2' : 'col-lg-3')">
					<div class="input-group">
						<div class="input-group-prepend">
							<div class="input-group-text limit-point">
								<label class="m-checkbox m-checkbox--success">
									<input v-model="filterVisible['4d']" type="checkbox">
									<span></span>
								</label>
							</div>
							<span class="input-group-text">4D &gt;=</span>
						</div>
						<input type="text" class="form-control m-input" v-model="propFilter['4d']">
					</div>
				</div>
				<div :class="'col-12 ' + (gameFilter == 2 ? 'col-lg-2' : 'col-lg-3')">
					<div class="input-group">
						<div class="input-group-prepend">
							<div class="input-group-text limit-point">
								<label class="m-checkbox m-checkbox--success">
									<input v-model="filterVisible['da']" type="checkbox">
									<span></span>
								</label>
							</div>
							<span class="input-group-text">Đá thẳng &gt;=</span>
						</div>
						<input type="text" class="form-control m-input" v-model="propFilter['da']">
					</div>
				</div>
				<div v-if="gameFilter == 2" :class="'col-12 ' + (gameFilter == 2 ? 'col-lg-2' : 'col-lg-3')">
					<div class="input-group">
						<div class="input-group-prepend">
							<div class="input-group-text limit-point">
								<label class="m-checkbox m-checkbox--success">
									<input v-model="filterVisible['dx']" type="checkbox">
									<span></span>
								</label>
							</div>
							<span class="input-group-text">Đá xiên &gt;=</span>
						</div>
						<input type="text" class="form-control m-input" v-model="propFilter['dx']">
					</div>
				</div>
			</div>
			<div class="row" style="padding: 15px;">
				<div class="col-12 col-sm-5">
					<button @click="this.getBettedRatioData" type="button" class="btn btn-brand m-btn m-btn--custom">Xem</button>
				</div>
			</div>
			
		</div>
		<div class="m-portlet__body">
			<div class="m-section">
				<div class="m-section__content">
					<div class="row table-content">
						<div v-if="filterVisible['2d']" class="col-12 col-md-6">
							<betted-table
								type="2d"
								title="2D"
								:header="header[gameFilter]['2d']"
								:channels="channel"
								:data="data"
								:game="gameFilter"
							></betted-table>
						</div>
						<div v-if="filterVisible['3d']" class="col-12 col-md-6">
							<betted-table
								type="3d"
								title="3D"
								:header="header[gameFilter]['3d']"
								:channels="channel"
								:data="data"
								:game="gameFilter"
							></betted-table>
						</div>
						<div v-if="filterVisible['4d']" class="col-12 col-md-4">
							<betted-table
								type="4d"
								title="4D"
								:header="header[gameFilter]['4d']"
								:channels="channel"
								:data="data"
								:game="gameFilter"
							></betted-table>
						</div>
						<div v-if="filterVisible['da']" class="col-12 col-md-4">
							<betted-table
								type="da"
								title="Đá"
								:header="header[gameFilter]['da']"
								:channels="channel"
								:data="data"
								:game="gameFilter"
							></betted-table>
						</div>
						<div v-if="gameFilter == 2 && filterVisible['dx']" class="col-12 col-md-4">
							<betted-table
								type="dx"
								title="Đá xiên"
								:header="header[gameFilter]['dx']"
								:channels="channel"
								:data="data"
								:game="gameFilter"
							></betted-table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import BettedRatioTable from "../BettedRatioTable";
	import groupBy from 'lodash/groupBy';

	export default {
		data(){
			let vm = this;

	        return {
	        	gameFilter: 2,
	        	header: {
					1: {
						"2d": [{'id':[1], 'value': 'Đầu', 'key': 'dau'},{'id':[2], 'value': 'Đuôi', 'key': 'duoi'},{'id':[3,4,5], 'value': 'Blô', 'key': 'blo'}],
						"3d": [{'id':[6], 'value': 'Đầu', 'key': 'dau'},{'id':[7], 'value': 'Đuôi', 'key': 'duoi'},{'id':[8,9,10], 'value': 'Blô', 'key': 'blo'}],
						"4d": [{'id':[11], 'value': 'Đuôi', 'key': 'duoi'},{'id':[12,13], 'value': 'Blô', 'key': 'blo'}],
						"da": [{'id':[14,15,16], 'value': 'Đá thẳng', 'key': 'da'}]
					},
					2: {
						"2d": [{'id':[1], 'value': 'Đầu', 'key': 'dau'},{'id':[2], 'value': 'Đuôi', 'key': 'duoi'},{'id':[3], 'value': '7lô', 'key': '7lo'},{'id':[4,5], 'value': 'Blô', 'key': 'blo'}],
						"3d": [{'id':[6], 'value': 'Đầu', 'key': 'dau'},{'id':[7], 'value': 'Đuôi', 'key': 'duoi'},{'id':[8], 'value': '7lô', 'key': '7lo'},{'id':[9,10], 'value': 'Blô', 'key': 'blo'}],
						"4d": [{'id':[11], 'value': 'Đuôi', 'key': 'duoi'},{'id':[12,13], 'value': 'Blô', 'key': 'blo'}],
						"da": [{'id':[14,15,16], 'value': 'Đá thẳng', 'key': 'da'}],
						"dx": [{'id':[17,18,19], 'value': 'Đá xiên', 'key': 'dx'}]
					},
					4: {
						"2d": [{'id':[1], 'value': 'Đầu', 'key': 'dau'},{'id':[2], 'value': 'Đuôi', 'key': 'duoi'},{'id':[3], 'value': '7lô', 'key': '7lo'},{'id':[4,5], 'value': 'Blô', 'key': 'blo'}],
						"3d": [{'id':[6], 'value': 'Đầu', 'key': 'dau'},{'id':[7], 'value': 'Đuôi', 'key': 'duoi'},{'id':[8], 'value': '7lô', 'key': '7lo'},{'id':[9,10], 'value': 'Blô', 'key': 'blo'}],
						"4d": [{'id':[11], 'value': 'Đuôi', 'key': 'duoi'},{'id':[12,13], 'value': 'Blô', 'key': 'blo'}],
						"da": [{'id':[14,15,16], 'value': 'Đá thẳng', 'key': 'da'}]
					}
	        	},
	        	todayChannels: [],
	        	channel: [],
	        	data: [],
				filterVisible: { '2d': true, '3d': true, '4d': true, 'da': true, 'dx': true },
				propFilter: { '2d': 500, '3d': 500, '4d': 200, 'da': 100, 'dx': 100 }
	        }
	    },

	    components: {
        	'betted-table': BettedRatioTable
        },

        mounted(){
        	this.todayChannels = this.getchannelsToday();
        	this.channel = this.todayChannels[this.gameFilter];
        },

        watch: {
        	gameFilter: function(val){
        		let vm = this;
        		this.channel = this.todayChannels[val];
        		this.data = [];
        	}
        },

    	computed: {
			...mapGetters({
				user: 'user',
		  		gameInfo: 'gameInfo'
			})
		},

	    methods: {
	        getBettedRatioData: function(){
	        	let vm = this;
	        	let game = vm.gameFilter;
				
				let propFilter = Object.keys(vm.propFilter).map(e => { return e+"="+vm.propFilter[e]; });
				propFilter.push("game="+game);
				let params = propFilter.join("&");

	        	window.axios.get("admin-panel/tools/betted-ratio?"+params)
    				.then((res) => {
    					res = res.data;
    					vm.data = res.data;
    				})
    				.catch((error) => {

    				});
	        },
	        getchannelsToday: function() {
	    		let vm = this;
				let ccc = [];
				for(let game in this.gameInfo.channelToday){
					let data = [];

					if(game == 3) {
						data = vm.gameInfo.channelToday[game].map((el) => {
	        				let chns = el.channel_id.split(".").map((cns) => { return vm.gameInfo.channels[parseInt(cns)].alias; });
	        				return { id: el.channel_id, text: chns.join(", "), gameId: game };
	        			});
					}else{
						data = vm.gameInfo.channelToday[game].map((el) => {
	        				return { id: el.channel_id, text: vm.gameInfo.channels[parseInt(el.channel_id)].alias, gameId: game };
	        			});
					}

        			ccc = ccc.concat(data);
				}

				ccc = groupBy(ccc, function(val){
	    			return val.gameId;
	    		});

				return ccc;
			},
	    }
	}

</script>
<style>
	.betted-ratio .m-portlet__head.row{
		padding: 0;
		padding-top: 10px;
	}
	.table-content{
		padding: 20px;
	}
	.filter-container{
		padding-left: 20px;
		padding-top: 10px;
	}
	.limit-point {
		padding-top: 5px;
		border-right: none;
	}
</style>